export interface ContentTemplate {
  name: string;
  content: string;
}

export const contentTemplates: ContentTemplate[] = [
  {
    name: 'Technical Article',
    content: `<p>Brief introduction paragraph that sets the context and hooks the reader with a problem or question.</p>

<blockquote><strong>TL;DR:</strong> One or two sentence summary of the key takeaway from this article.</blockquote>

<h2>Understanding the Challenge</h2>
<p>Explain the problem or situation in detail. Why does this matter? What are the implications?</p>

<h2>The Solution</h2>
<p>Present your main solution or insight. Break down complex ideas into digestible pieces.</p>

<h3>Key Benefits</h3>
<ul>
<li>First major benefit</li>
<li>Second major benefit</li>
<li>Third major benefit</li>
</ul>

<h2>How It Works</h2>
<p>Provide technical details, process steps, or methodology. Use clear language that balances depth with accessibility.</p>

<h2>Real-World Applications</h2>
<p>Share specific examples, case studies, or use cases that demonstrate the value.</p>

<h2>Next Steps</h2>
<p>Clear call-to-action paragraph. What should the reader do with this information?</p>

<p><strong>Ready to learn more?</strong> Contact our team for expert guidance on your specific situation.</p>`
  },
  {
    name: 'Product Guide',
    content: `<p>Opening paragraph that introduces the product and its primary purpose.</p>

<blockquote><strong>Quick Take:</strong> The main reason why this product matters for your operations.</blockquote>

<h2>What Makes It Different</h2>
<p>Explain the unique value proposition. What sets this apart from alternatives?</p>

<h2>Key Features</h2>
<ul>
<li>Feature one with brief explanation</li>
<li>Feature two with brief explanation</li>
<li>Feature three with brief explanation</li>
<li>Feature four with brief explanation</li>
</ul>

<h2>Common Applications</h2>
<p>Describe the typical scenarios where this product excels.</p>

<h3>Industry Examples</h3>
<ul>
<li>Agriculture: specific use case</li>
<li>Municipal: specific use case</li>
<li>Industrial: specific use case</li>
</ul>

<h2>Technical Specifications</h2>
<p>Provide relevant technical details without overwhelming the reader.</p>

<h2>Get Started</h2>
<p>Clear call-to-action with contact information or next steps.</p>`
  },
  {
    name: 'How-To Guide',
    content: `<p>Introduction explaining what this guide covers and who it's for.</p>

<blockquote><strong>What You'll Learn:</strong> Key outcomes the reader will achieve by following this guide.</blockquote>

<h2>Before You Begin</h2>
<p>Prerequisites, tools needed, or important considerations.</p>

<h2>Step 1: [First Major Step]</h2>
<p>Detailed explanation of the first step with clear instructions.</p>

<h3>Important Considerations</h3>
<ul>
<li>Key point to remember</li>
<li>Common mistake to avoid</li>
</ul>

<h2>Step 2: [Second Major Step]</h2>
<p>Detailed explanation of the second step.</p>

<h2>Step 3: [Third Major Step]</h2>
<p>Detailed explanation of the third step.</p>

<h2>Troubleshooting Common Issues</h2>
<p>Address frequent questions or problems that may arise.</p>

<h2>Wrapping Up</h2>
<p>Summary and encouragement. Next steps or additional resources.</p>`
  },
  {
    name: 'Problem-Solution',
    content: `<p>Hook the reader with a relatable problem statement that resonates with your audience.</p>

<blockquote><strong>The Bottom Line:</strong> Quick summary of the solution and its impact.</blockquote>

<h2>The Problem in Detail</h2>
<p>Expand on the challenge. Use specific examples and data when possible.</p>

<h3>Common Symptoms Include</h3>
<ul>
<li>Symptom or consequence one</li>
<li>Symptom or consequence two</li>
<li>Symptom or consequence three</li>
</ul>

<h2>Why Traditional Approaches Fall Short</h2>
<p>Explain why existing solutions don't fully address the problem.</p>

<h2>A Better Approach</h2>
<p>Introduce your solution and explain why it works better.</p>

<h3>Key Advantages</h3>
<ul>
<li>Advantage one</li>
<li>Advantage two</li>
<li>Advantage three</li>
</ul>

<h2>Proven Results</h2>
<p>Share evidence, case studies, or testimonials that demonstrate effectiveness.</p>

<h2>Take Action</h2>
<p>Clear call-to-action that guides readers to the next step.</p>`
  }
];
